import { useEffect, useState } from 'react';

export interface User {
    id: string;
    email: string;
    altemail?: string;
    person?: {
        id: string;
        firstName: string;
        lastName: string;
        phone: string;
        address: string;
        houseNumber: string;
        city: string;
        psc: string;
        type: 'PARENT' | 'ADULT' | 'KID';
    }[];
}

export function useCurrentUser() {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_PATH}/api/user/data/profile`, {
                    credentials: 'include',
                });

                if (res.ok) {
                    const response = await res.json();
                    const userData: User = {
                        id: response.data?.id || '',
                        email: response.user?.email || '',
                        altemail: response.data?.altemail,
                        person: response.data?.person || []
                    };
                    setUser(userData);
                } else {
                    setUser(null);
                }
            } catch (err) {
                console.error('Failed to fetch user', err);
                setUser(null);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);

    return { user, loading };
}
